import * as actionTypes from "../constants/actionTypes";
import * as config from "../config";

export function storeRegistrationMethod(registrationMethod) {
	localStorage.setItem(config.storageKeys.registrationMethod, registrationMethod);
	return {
		type: actionTypes.REGISTRATION_METHOD_STORE,
		registrationMethod,
	};
}


export function clearRegistrationMethod(registrationMethod) {
	localStorage.removeItem(config.storageKeys.registrationMethod);
	return {
		type: actionTypes.REGISTRATION_METHOD_STORE,		
	};
}
